export const parseErrorFromResponse = response => {
  if (!response.error) return null;
  return (
    response.error?.data?.errors?.[0]
    || response?.error?.message
  );
};